module.exports = __webpack_public_path__ + "img/service_2.a8ce1811.png";